const settings = {
  API_URL: process.env.VUE_APP_API_URL,
  APP_URL: process.env.VUE_APP_URL,
  APP_TITLE: process.env.VUE_APP_TITLE,
  ENV: process.env.NODE_ENV,
  VERSION: process.env.VERSION,
};

export default settings;
